import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'

import { useLoader } from '@/providers/loader/LoaderProvider'
import { useSession } from '@/providers/session/SessionProvider'
import BackToLogin from '@/components/Login/BackToLogin'

import * as SecurityApi from '@/api/security'
import { TWO_FA, EMAIL_SENT } from '@/routes'

import './RecoverPassword.scss'

const PasswordRecover = () => {
  const { push } = useHistory()
  const { setLoading } = useLoader()
  const { userEmail } = useSession()
  const { formatMessage } = useIntl()
  // The phone's last digits only exist after a valid password, so the code option has no description.

  const handleCodeReset = useCallback(async () => {
    try {
      setLoading(true)
      await SecurityApi.resetPasswordWith2FA({ email: userEmail })
      push({ pathname: TWO_FA, state: { pwdReset: true } })
    } finally {
      setLoading(false)
    }
  }, [push, setLoading, userEmail])

  const handleEmailReset = useCallback(async () => {
    try {
      setLoading(true)
      await SecurityApi.resetPassword(userEmail)
      push(EMAIL_SENT)
    } finally {
      setLoading(false)
    }
  }, [push, setLoading, userEmail])

  return (
    <div className="content-wrapper recover-password">
      <div className="login-titles">
        <div className="title">
          <FormattedMessage id="recoverPassword.title" />
        </div>
        <div className="sub-title">
          <FormattedMessage id="recoverPassword.subTitle" />
        </div>
      </div>
      <form className="login-form-wrapper">
        <ul className="login-field-wrapper">
          <li>
            <button type="button" className="recovery-option" onClick={handleCodeReset}>
              <span className="recovery-option__icon recovery-option__icon--code" aria-hidden="true" />
              <span className="recovery-option__text">
                <span className="recovery-option__title">
                  <FormattedMessage id="recoverPassword.sendCode" />
                </span>
              </span>
              <span className="recovery-option__chevron" aria-hidden="true" />
            </button>
          </li>
          <li>
            <button type="button" className="recovery-option" onClick={handleEmailReset}>
              <span className="recovery-option__icon recovery-option__icon--email" aria-hidden="true" />
              <span className="recovery-option__text">
                <span className="recovery-option__title">
                  <FormattedMessage id="recoverPassword.sendLink" />
                </span>
                {userEmail && (
                  <span className="recovery-option__description">
                    {formatMessage({ id: 'recoverPassword.emailDescription' }, { email: userEmail })}
                  </span>
                )}
              </span>
              <span className="recovery-option__chevron" aria-hidden="true" />
            </button>
          </li>
        </ul>
      </form>
      <div className="login-buttons-wrapper">
        <BackToLogin />
      </div>
    </div>
  )
}

export default PasswordRecover
